const POSITION_CONFIG = require("./CampaignAreaPositionConfig")

const constants = () => {
  const MAX_COLUMNS = 20

  const MAX_PROMO_AREAS = 3

  const INITIAL_TAB = '0'

  const DEFAULT_COLUMNS = {
    show_carousel: false,
    show_icons: true,
    show: false,
    alignment: 0,
    size: 0,
    items: {
      '0': {
        key: '0',
        url: null,
        icon: 'c-idea',
        text: null,
        title: null
      },
      '1':{
        key: '1',
        url: null,
        icon: 'c-trophy',
        text: null,
        title: null
      },
      '2':{
        key: '2',
        url: null,
        icon: 'c-call',
        text: null,
        title: null
      }
    }
  }

  const DEFAULT_AREA = {
    show: true,
    position: POSITION_CONFIG.DEFAULT_POSITION,
    title:{
      title: null,
      subtitle: null
    },
    columns: DEFAULT_COLUMNS,
    cta:{
      show: false,
      text: null,
      type: null,
      metadata: {
        url: null,
        form_id: null
      },
      transparent: false,
      form: null,
      privacy_message: null
    }
  }

  const DEFAULT_COLUMN = {
    key: -1,
    icon: -1,
    text: null,
    title: null,
    url: null
  }

  const LARGE_COLUMNS_IN_ROW = {
    one: {name: '1 in a row', value: 1},
    two: {name: '2 in a row', value: 2},
    three: {name: '3 in a row', value: 3},
  }

  const SMALL_COLUMNS_IN_ROW = {
      ...LARGE_COLUMNS_IN_ROW,
      four: {name: '4 in a row', value: 4}
  }

  return {
    DEFAULT_AREA, DEFAULT_COLUMNS, DEFAULT_COLUMN, MAX_COLUMNS,
    MAX_PROMO_AREAS, INITIAL_TAB, SMALL_COLUMNS_IN_ROW,
    LARGE_COLUMNS_IN_ROW
  }
}

module.exports = constants()